'use strict';
class Loader {
    constructor() {
        this._queue = 0;
    }

    initialize(progressBar) {
        this._progressBar = progressBar;
    }

    start() {
        this._queue++;
        this._progressBar.start();
    }

    end() {
        this._queue--;
        if (this._queue <= 0) {
            this._progressBar.end();
        }
    }

    loading(callback) {
        this.loadStart();
        let deferred = callback();
        deferred.always(function(){
            this.loadEnd();
        });
        return deferred;
    }
}

module.exports = new Loader();



// WEBPACK FOOTER //
// ./common/infra/loader.js